import React from 'react';
import { Wrench } from 'lucide-react';
import Tooltip from '../../../common/Tooltip';

interface Tool {
  type: string;
  name?: string;
  description?: string;
}

export interface ToolIndicatorProps {
  tools: Tool[];
  onClick: (e: React.MouseEvent) => void;
}

/**
 * ToolIndicator - A compact indicator showing just wrench icon and count.
 * Opens a modal on click to display detailed tool information.
 * AC-636: Changed from "Tools (2)" to just icon + number for cleaner UX.
 */
const ToolIndicator: React.FC<ToolIndicatorProps> = ({ tools, onClick }) => {
  if (!tools || tools.length === 0) return null;

  return (
    <Tooltip content={`${tools.length} tool${tools.length > 1 ? 's' : ''} - Click to view`}>
      <button
        type="button"
        onClick={onClick}
        className="flex items-center gap-1 px-1.5 py-0.5 rounded-full bg-orange-100 dark:bg-orange-900/40 text-orange-700 dark:text-orange-300 text-xs font-medium hover:bg-orange-200 dark:hover:bg-orange-900/60 transition-colors"
      >
        <Wrench className="w-3 h-3" />
        <span>{tools.length}</span>
      </button>
    </Tooltip>
  );
};

export default ToolIndicator;
